import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { Observable } from 'rxjs/Observable';
import { ClientData } from '../providers/client';
import { ENV } from "@app/env";

@Pipe({
  name: 'ClientCurrency'
})

export class ClientCurrencyPipe implements PipeTransform {

  currency: CurrencyPipe;

  constructor(
    private clientData: ClientData,
  ) { this.currency = new CurrencyPipe('en-US') }

  transform(value: any): Observable<any> {
    return this.clientData._searchClient(ENV.client)
      .map((item: any) => {
        return this.currency.transform(value, this.transformCodeCurrency(item.currency), 'symbol', this.verifiedNumDigit(item.currency));
      });
  }

  private verifiedNumDigit(currency: string): string {
    switch (currency) {
      case 'COP':
        return '1.0-0';
      default:
        return '1.0-2';
    }
  }

  private transformCodeCurrency(currency: string): string {
    switch (currency) {
      case 'COP':
        return 'USD';
      default:
        return 'USD';
    }
  }
}


// WEBPACK FOOTER //
// ./src/pipes/client-currency.pipe.ts